import BaseModel from 'src/model/base.model';
import OrderModel from './order.model';

export default class OrdersModel extends BaseModel {
  public data: OrderModel[];
  public pageNumber: number;
  public pageSize: number;
  public totalElements: number;
  public totalPages: number;
}
